import { createApp } from 'vue'
// import './style.css'
// element-plus
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import 'element-plus/dist/index.css'
import '@/assets/styles/index.scss'
import './permission' // permission control
import App from './App.vue'
// 路由设置
import router from './router/index'
import { createPinia } from 'pinia'
import IconFont from '@/components/icon-font.vue'

const app = createApp(App)

app
  .use(router)
  .use(createPinia())
  .use(ElementPlus, {
    locale: zhCn,
  })
  .component('IconFont', IconFont)


app.mount('#app')

export default app
